import React, {useEffect, useState} from 'react';
import TitleBar from 'components/Navigation/TitleBar';
import ListCard from 'components/ListCard';
import Container from 'components/Container';
import Mapper from 'components/Mapper';
import {useHistory} from 'react-router';
import {ROOT_PATH} from 'constants/routes';
import styled from 'styled-components';
import formatNumber from 'helpers/formatNumber';
import {ChevronRight} from 'react-feather';
import Description from 'components/Description';
import PropTypes from 'prop-types';
import Loader from 'components/Loader';
import {useTranslate} from 'helpers/translate';
import {path} from "ramda";
import ModalCheckout from "../../../ModalCheckout";
import AddAddressModal from "../../../ModalCheckout/AddAddress/AddAddressModal";
import {appendParamsToUrl, parseParams} from "../../../../helpers/url";
import * as PATH from "../../../../constants/routes";

const Total = styled('div')`
  margin-top: 10px;
  background: white;
  padding: 15px;
  box-shadow: 0 1px 3px rgb(0 0 0 / 5%);
  border-radius: 10px;
`

const BtnWrap = styled('div')`
    width: 100%;
    padding: 10px 10px 25px 10px;
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
`

const Fixed = styled('div')`
    width: 100%;
    height: 55px;
    background: linear-gradient(180deg, #4c956c 0%, #4c956c 100%);
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    color: white;
    border-radius: 20px;
`

const Basket = styled('div')`
  width: max-content;
  display: flex;
  align-items: center;
  justify-content: space-between;

  & svg {
    margin-top: 3px;
    margin-left: 3px;
  }
`

const styles = {
  wrapper: {
    marginTop: '5px'
  },
  button: {
    marginTop: '15px'
  },
  parent: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '18px',
    lineHeight: '23px',
    display: 'flex',
    alignItems: 'center',
    color: "#333333"
  },
  child: {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    lineHeight: '23px',
    display: 'flex',
    alignItems: 'center',
    textAlign: 'right',
    color: '#4c956c'
  }
}

const BasketGrid = (props) => {
  const {products, total, loading} = props
  const [openAddress, setOpenAddress] = useState(false)
  const [refetch, setRefetch] = useState(false)
  const [loading1, setLoading] = useState(false)
  const [detail, setDetail] = useState(null)
  useEffect(() => {
    if (loading1) {
      setTimeout(() => setLoading(false), 300)
    }
  }, [loading1])
  const history = useHistory()
  const location = path(['location'], history)
  const search = path(['location', 'search'], history)
  const searchObj = parseParams(search)
  const {t} = useTranslate()
  const currency = path(['0', 'currency', 'sign'], products)

  const isOpenAuth = path(['openAuth'], searchObj) === 'true'

  const onOpenAuth = () => {
    history.push({
      pathname: location.pathname,
      search:appendParamsToUrl({openAuth: true}, search)
    })
  }

  const onCloseAuth = () => {
    history.push({
      pathname: location.pathname,
      search:appendParamsToUrl({openAuth: false}, search)
    })
  }

  return (
    <>
      <TitleBar
        title={t('basket')}
        icon={'back'}
        onClick={() => {
          history.push({
            pathname: ROOT_PATH
          })
        }}
      />
      <Container hasStatusBar hasFixedBar bottom={'100px'}>
        <Total>
          <Description
            withOutMargin
            parent={t('order_price')}
            child={formatNumber(total, currency, ' ')}
            parentStyles={styles.parent}
            childStyles={styles.child}
          />
        </Total>
        <Mapper
          loading={loading1}
          data={products}
          itemProps={{
            onDelete: () => setLoading(true)
          }}
          item={ListCard}
        />
        {isOpenAuth && (
          <ModalCheckout
            products={products}
            setOpenAddress={setOpenAddress}
            open={isOpenAuth}
            onClose={() => onCloseAuth()}
            refetch={refetch}
            setDetail={setDetail}
          />
        )}
        <AddAddressModal
          open={openAddress}
          onClose={() => setOpenAddress(false)}
          onSuccess={() => setRefetch((prev) => !prev)}
          detail={detail}
        />

        <BtnWrap>
          <Fixed
            onClick={() => {
              !loading && onOpenAuth()
            }}
          >
            {
              loading ?
                <Loader/>
                :
                <>
                  <p>{formatNumber(total, currency, ' ')}</p>
                  <Basket>
                    <p>{t('go_to_checkout')}</p>
                    <ChevronRight size={20}/>
                  </Basket>
                </>
            }
          </Fixed>
        </BtnWrap>
      </Container>
    </>
  )
}

BasketGrid.propTypes = {
  total: PropTypes.any.isRequired,
  products: PropTypes.any.isRequired
}

export default BasketGrid
